import { useAuth } from "react-oidc-context";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

/**
 * Where the button in a sign-in code email lands (/auth/code).
 *
 * radaccess points that button here (owner, 2026-10-02) instead of leaving it
 * on ZITADEL's default, a page of ZITADEL's hosted login that knows nothing
 * about a sign-in this console is driving and could only answer "Could not get
 * the context of the user".
 *
 * 🔑 This page CANNOT sign anyone in, and must not try. The sign-in lives in
 * the tab the person started in; the code is what completes it, typed there.
 * The link deliberately carries no code and no user data -- radaccess refuses a
 * templated link -- so there is nothing here to read from the URL.
 */
export function EmailCodeHelp() {
  // The same restart the sign-in page offers: a fresh authorize request, never
  // a link to a page that needs one.
  const auth = useAuth();
  return (
    <Container maxWidth="sm" sx={{ py: { xs: 4, sm: 8 } }}>
      <Paper sx={{ p: { xs: 3, sm: 4 } }}>
        <Stack spacing={2}>
          <Typography variant="h5" component="h1">
            Type the code where you started
          </Typography>
          <Typography variant="body1">
            Your sign-in code is in the email you just opened. Go back to the AnkhOS tab where you
            started signing in, and type the code there.
          </Typography>
          <Alert severity="info">
            This button cannot sign you in by itself. That is on purpose: it means someone who sees a
            forwarded copy of the email cannot use it to sign in as you.
          </Alert>
          <Typography variant="body2" color="text.secondary">
            The code works for 5 minutes. If you closed that tab, or the code has expired, start again.
          </Typography>
          <Box>
            <Button variant="outlined" onClick={() => void auth.signinRedirect()}>
              Start signing in again
            </Button>
          </Box>
        </Stack>
      </Paper>
    </Container>
  );
}
